 <template>
  <div class="part-container">
    <!-- 头部 -->
    <div class="part-header">
      <div class="header-title">{{ title }}</div>
      <div v-if="displayItems.length > 0"  class="header-more" @click="handleMore"><span class="plus">+</span>&nbsp;&nbsp;更多</div>
    </div>

    <!-- 内容列表 -->
    <div class="part-content">
      <div
        v-for="(item, index) in displayItems"
        :key="index"
        class="part-item"
        @click="handleItemClick(item)"
      >
        <div class="item-title">{{ item.title }}</div>
        <div class="item-content">{{ item.description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailList',
  props: {
    // 头部标题
    title: {
      type: String,
      required: true,
    },
    // 数据列表
    list: {
      type: Array,
      default: () => [],
    },
    // 最大显示数量
    maxItems: {
      type: Number,
      default: 12,
    },
    // 默认显示数量
    defaultItems: {
      type: Number,
      default: 2,
    },
    // 问题类型
    questionType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    // 是否显示展开按钮
    showExpandButton() {
      return this.list.length > 2;
    },
    // 当前显示的条目数量
    currentItemCount() {
      if (!this.isExpanded) {
        return Math.min(this.defaultItems, this.list.length);
      }
      return Math.min(this.maxItems, this.list.length);
    },
    // 当前显示的条目
    displayItems() {
      return this.list.slice(0, this.currentItemCount);
    },
  },
  methods: {
    handleMore() {
      if(this.questionType == '8'){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-8-服务-相关信息-更多', 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-8-服务-相关信息-更多');
      }else if(this.questionType == '9'){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-9-其他-相关信息-更多', 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-9-其他-相关信息-更多');
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), 'question-Details-多模态-相关信息-更多', 1]);
        stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-相关信息-更多');
      }
      // 触发父组件事件
      this.$emit('more-click','announcement');
    },
    // 切换展开/收起状态
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    // 处理条目点击
    handleItemClick(item) {
        if(this.questionType == '8'){
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-8-服务-相关信息： '+ item.title, 1]);
          stm_clicki("send",'event',window.location.href, "点击", 'question-8-服务-相关信息： '+ item.title);
        }else if(this.questionType == '9'){
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),  'question-9-其他-相关信息： '+ item.title, 1]);
          stm_clicki("send",'event',window.location.href, "点击", 'question-9-其他-相关信息： '+ item.title);
        }else{
          _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), 'question-Details-多模态-相关信息： '+ item.title, 1]);
          stm_clicki("send",'event',window.location.href, "点击", 'question-Details-多模态-相关信息： '+ item.title);
        }  
        if (item.url) {
          //打开新网页链接
          window.open(item.url);
        }
      },
  },
};
</script>

<style lang="scss">
@import './style/part.css';
.part-item:hover {
        // background-color: rgba(225, 229, 234, 0.5);
      }
  .header-more {
    display: inline-flex;
    align-items: center;
    line-height: 1;
    cursor: pointer;
  }
  .header-more .plus {
    font-size: calc((18 / 1920) * 100vw); /* 加号稍微大一点 */
    display: inline-block;
    transform: translateY(calc((0 / 1920) * 100vw)); /* 微调视觉对齐 */
  }
</style>
